import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OtherMoudleService } from '../othermodule.service';
import { AuthService } from 'app/auth/auth.service';
import { DatePipe } from '@angular/common';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import * as moment from 'moment';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { labResultModal } from '../Model/otherModule.model';
import { FormControl } from '@angular/forms';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import { SortableComponent } from 'ngx-bootstrap';
// import { DashboardService } from 'app/dashboard/dashboard.service';
// import { ReportserviceService } from '../reportservice.service';
// import { debug } from 'console';

@Component({
  selector: 'app-testresultentry-panel',
  templateUrl: './testresultentry.component.html',
  styleUrls: ['./testresultentry.component.scss']
})
export class TestResultEntryComponent implements OnInit {
  destroytestResultlist$: Subject<boolean> = new Subject<boolean>();
  private branchList: any[] = [];
  branchControl: FormControl;
  autoapproveStatusControl: FormControl;
  autoclinicalControl: FormControl;
  autodeliveryControl: FormControl;
  filteredLabBranchArray: Observable<any[]>;
  filteredLabapproveStatusArray: Observable<any[]>
  filteredclinicalArray: Observable<any[]>
  filteredDeliveryArray: Observable<any[]>

  private labSampleCollectionDetailArray: any[] = [];
  private sampleCollectionDetailByBillIdArray: any[] = [];
  private clinicalArray: any[] = [];
  private approvalArray: any[] = [];
  private deliveryArray: any[] = [];
  editCache: any = {};
  labResultEntryModel: labResultModal = {}
  BranchId: any
  BranchName: any
  startdate: any
  enddate: any
  currentRoute: any = '';
  cleanRoute: any
  constructor(private otherService: OtherMoudleService,
    private authService: AuthService,
    private dashboardService: DashboardService,
    private datePipe: DatePipe,
    public branchMatserService: BranchMatserService,
    private ipdService: IPDService,
    private router: Router) {
  }

  ngOnInit(): void {
    this.currentRoute = this.router.url;
    this.labResultEntryModel.approveStatus = 'Pending';
    this.labResultEntryModel.deliveryStatus = 'Pending';
    this.labResultClinical('LABRESULTCLINICALDEPT');
    this.cleanRoute = this.currentRoute.startsWith('/') ? this.currentRoute.slice(1) : this.currentRoute;

    if (this.cleanRoute == 'labentry/testresultentry') {
      this.labResultApprovalSta('LABRESULTAPPROVALSTATUS');
      this.startdate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
      this.enddate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    } else {
      this.labResultApprovalSta('LABRESULTTESTAPPROVALSTATUS');
      this.labResultEntryModel.deliveryStatus = null;
      this.startdate = null;
      this.enddate = null;
    }
    // if(this.currentRoute == 'testresultentry'){
    //   this.labResultApprovalSta('LABRESULTAPPROVALSTATUS');
    // }else{
    //    this.labResultApprovalSta('LABRESULTTESTAPPROVALSTATUS');
    // }
    this.labResultDeliverySta();
    this.labResultEntryModel.branchName = this.authService.Loggeduser.branchname;
    this.labResultEntryModel.BranchId = this.authService.Loggeduser.branchid;

    this.initializeLabBranchControl();
    this.labSampleCollectionDetail();
    this.autoapproveStatusControl = new FormControl();
    this.autoclinicalControl = new FormControl();
    this.autodeliveryControl = new FormControl();
    this.getBranchDetail(this.authService.Loggeduser.branchid);
  }


  onBranchLabSelected(event) {
    this.labResultEntryModel.branchName = event.value;
    this.labResultEntryModel.BranchId = event.id;
    this.labSampleCollectionDetail();
    this.getBranchDetail(this.labResultEntryModel.BranchId);
  }

  initializeLabBranchControl() {
    this.branchControl = new FormControl();
    this.filteredLabBranchArray = this.branchControl.valueChanges.pipe(
      startWith(""),
      map((branch) =>
        branch
          ? this.filterLabBranchFunction(branch)
          : this.authService.Branches.slice()
      )
    );
  }

  filterLabBranchFunction(name: string): any[] {
    return this.authService.Branches.filter((branch) =>
      branch.branchName.toLowerCase().includes(name.toLowerCase())
    );
  }

  clearLabBranchName(lbid: any) {
    if (!lbid) {
      this.labResultEntryModel.BranchId = null;
    }
  }

  labResultClinical(type) {
    this.otherService.labResultClinicalDept(type).pipe(takeUntil(this.destroytestResultlist$)).subscribe((res) => {
      this.clinicalArray = res;
      this.initializeLabclinicalControl();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  initializeLabclinicalControl() {
    this.autoclinicalControl = new FormControl();
    this.filteredclinicalArray = this.autoclinicalControl.valueChanges.pipe(
      startWith(""),
      map((cname) =>
        cname
          ? this.filterLabclinicalFunction(cname)
          : this.clinicalArray.slice()
      )
    );
  }

  filterLabclinicalFunction(cname: string): any[] {
    return this.clinicalArray.filter((clinic) =>
      clinic.name.toLowerCase().includes(cname.toLowerCase())
    );
  }

  onclinicalLabSelected(event) {
    this.labResultEntryModel.clinicalName = event.value;
    this.labResultEntryModel.clinicalId = event.id;
    // this.labSampleCollectionDetail();
    this.filteredSampleCollectionDetails = this.sampleCollectionDetailByBillIdArray.filter(item =>
      item.departmentName?.toLowerCase() === this.labResultEntryModel.clinicalName.toLowerCase()
    );
    // this.getLabResultArray = null;
    // this.selectedIndex2 = null;
    // this.labResultEntryModel.remark = null;
    this.applyCombinedFilter();
  }

  clearLabclinical(cid: any) {
    if (!cid) {
      this.labResultEntryModel.clinicalId = null
      if (this.selectedpK_BIllID) {
        let Payload = {
          "BillID": this.selectedpK_BIllID
        }
        this.otherService.GetLabSampleCollectionDetailByBillId(Payload).pipe(takeUntil(this.destroytestResultlist$)).subscribe((res) => {
          this.sampleCollectionDetailByBillIdArray = res;
          if (this.sampleCollectionDetailByBillIdArray.length > 0) {
            this.selectedIndex2 = null
            this.labResultEntryModel.remark = null
            // this.printArray = null;
            // this.getLabResult(this.sampleCollectionDetailByBillIdArray[0].pK_TranID, this.sampleCollectionDetailByBillIdArray[0].pK_ServiceId, this.sampleCollectionDetailByBillIdArray[0].pK_BIllID, this.sampleCollectionDetailByBillIdArray[0].pType)
          }
          this.filteredSampleCollectionDetails = [...res];

        }, err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        })
      }
    }
  }


  applyCombinedFilter() {
    let sinFilter = this.labResultEntryModel.SINNO?.toLowerCase() || '';
    let testNameFilter = this.labResultEntryModel.TestName?.toLowerCase() || '';
    let clinicalFilter = this.labResultEntryModel.clinicalName?.toLowerCase() || '';

    this.filteredSampleCollectionDetails = this.sampleCollectionDetailByBillIdArray.filter(item =>
      item.sinNo?.toLowerCase().includes(sinFilter) &&
      item.testName?.toLowerCase().includes(testNameFilter) &&
      item.departmentName?.toLowerCase().includes(clinicalFilter)
    );

    this.getLabResultArray = null;
    this.selectedIndex2 = null;
    this.labResultEntryModel.remark = null;
  }


  labResultApprovalSta(type) {
    this.otherService.labResultApprovalStatus(type).pipe(takeUntil(this.destroytestResultlist$)).subscribe((res) => {
      this.approvalArray = res;
      this.initializeLabapproveStatusControl();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  // initializeLabapproveStatusControl() {
  //   this.autoapproveStatusControl = new FormControl();
  //   this.filteredLabapproveStatusArray = this.autoapproveStatusControl.valueChanges.pipe(
  //     startWith(""),
  //     map((status) =>
  //       status
  //         ? this.filterLabapproveStatusFunction(status)
  //         : this.approvalArray.slice()
  //     )
  //   );
  // }

  initializeLabapproveStatusControl() {
    this.autoapproveStatusControl = new FormControl(this.labResultEntryModel.approveStatus || '');

    this.filteredLabapproveStatusArray = this.autoapproveStatusControl.valueChanges.pipe(
      startWith(this.labResultEntryModel.approveStatus || ''),
      map((status) =>
        status
          ? this.filterLabapproveStatusFunction(status)
          : this.approvalArray.slice()
      )
    );
  }

  filterLabapproveStatusFunction(name: string): any[] {
    return this.approvalArray.filter((status) =>
      status.status.toLowerCase().includes(name.toLowerCase())
    );
  }

  onapproveStatusLabSelected(event) {
    this.labResultEntryModel.approveStatus = event.value;
    this.labResultEntryModel.statusId = event.id;
    this.labSampleCollectionDetail();

  }

  clearLabapproveStatusName(aid: any) {
    if (!aid) {
      this.labResultEntryModel.statusId = null;
    }
  }



  selectStatus(e) {
    const selectedStatus = this.approvalArray.find(
      (loc) => loc.status == e.value
    );
    if (selectedStatus) {
      this.labResultEntryModel.approveStatus = selectedStatus.status;
      this.labResultEntryModel.statusId = selectedStatus.id;
    }
    this.labSampleCollectionDetail();
  }

  labResultDeliverySta() {
    this.otherService.labResultDeliveryStatus().pipe(takeUntil(this.destroytestResultlist$)).subscribe((res) => {
      this.deliveryArray = res;
      this.initializeLabDeliveryControl();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  initializeLabDeliveryControl() {
    // this.autodeliveryControl = new FormControl();
    // this.filteredDeliveryArray = this.autodeliveryControl.valueChanges.pipe(
    //   startWith(""),
    //   map((status) =>
    //     status
    //       ? this.filterLabDeliveryFunction(status)
    //       : this.deliveryArray.slice()
    //   )
    // );
    this.autodeliveryControl = new FormControl(this.labResultEntryModel.deliveryStatus || '');

    this.filteredDeliveryArray = this.autodeliveryControl.valueChanges.pipe(
      startWith(this.labResultEntryModel.deliveryStatus || ''),
      map((status) =>
        status
          ? this.filterLabDeliveryFunction(status)
          : this.deliveryArray.slice()
      )
    );
  }

  filterLabDeliveryFunction(name: string): any[] {
    return this.deliveryArray.filter((status) =>
      status.status.toLowerCase().includes(name.toLowerCase())
    );
  }

  onDeliveryLabSelected(event) {
    this.labResultEntryModel.deliveryStatus = event.value;
    this.labResultEntryModel.deliveryId = event.id;
    this.labSampleCollectionDetail();
  }

  clearLabDeliveryName(did: any) {
    if (!did) {
      this.labResultEntryModel.deliveryId = null;
    }
  }

  selectDStatus(e) {
    const selectedDStatus = this.deliveryArray.find(
      (loc) => loc.status == e.value
    );
    if (selectedDStatus) {
      this.labResultEntryModel.deliveryStatus = selectedDStatus.status;
      this.labResultEntryModel.deliveryId = selectedDStatus.id;
    }
    this.labSampleCollectionDetail();
  }
  searchByPara(value: any, type: any) {
    if (type == 1) {
      this.labResultEntryModel.PatientName = value;
    } else if (type == 2) {
      this.labResultEntryModel.PatientID = value;
    } else if (type == 3) {
      this.labResultEntryModel.BillNo = value;
    } else if (type == 4) {
      this.labResultEntryModel.SINNO = value;
    }
    // } else if (type == 5) {
    //   this.labResultEntryModel.TestName = value;
    // }
    this.labSampleCollectionDetail();
  }


  // onFromDateChange() {
  //   this.labSampleCollectionDetail();
  // }
  onFromDateChange() {
    if (this.enddate && this.enddate < this.startdate) {
      this.enddate = null;
    }
    this.labSampleCollectionDetail();
  }
  onFromToChange() {
    this.labSampleCollectionDetail();
  }
  labSampleCollectionDetail() {
    if (this.getLabResultArray && this.getLabResultArray.length > 0) {
      this.getLabResultArray.forEach((item, index) => {
        if (this.editCache[index] && this.editCache[index].edit) {
          this.editCache[index].edit = false;
        }
      });
    }
    let Payload = {
      "Fromdate": this.startdate ? moment(this.startdate).format('YYYY-MM-DD') : '1900-01-01',
      "Todate": this.enddate ? moment(this.enddate).format('YYYY-MM-DD') : '1900-01-01',
      "BranchID": this.labResultEntryModel.BranchId,
      "SINNO": this.labResultEntryModel.SINNO ? this.labResultEntryModel.SINNO : null,
      "LabDepartmentID": this.labResultEntryModel.clinicalId ? this.labResultEntryModel.clinicalId : null,
      "ApprovalStatus": this.labResultEntryModel.approveStatus ? this.labResultEntryModel.approveStatus : null,
      "PatientName": this.labResultEntryModel.PatientName ? this.labResultEntryModel.PatientName : null,
      "PatientID": this.labResultEntryModel.PatientID ? this.labResultEntryModel.PatientID : null,
      "BillNo": this.labResultEntryModel.BillNo ? this.labResultEntryModel.BillNo : null,
      "TestName": this.labResultEntryModel.TestName ? this.labResultEntryModel.TestName : null,
      "DeliveryStatus": this.labResultEntryModel.deliveryStatus ? this.labResultEntryModel.deliveryStatus : null
    }
    this.otherService.GetLabSampleCollectionDetail(Payload).pipe(takeUntil(this.destroytestResultlist$)).subscribe((res: any) => {
      this.labSampleCollectionDetailArray = res;
      this.sampleCollectionDetailByBillIdArray = null;
      this.filteredSampleCollectionDetails = null
      this.getLabResultArray = null;
      this.selectedIndex = null;
      this.selectedIndex2 = null;
      this.labResultEntryModel.remark = null;
      this.labResultEntryModel.clinicalName = null;
      this.labResultEntryModel.SINNO = null;
      this.labResultEntryModel.TestName = null;
      // this.printArray = null;
      this.labResultClinical('LABRESULTCLINICALDEPT');
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  selectedpK_BIllID: any
  patient_Id: any
  filteredSampleCollectionDetails: any[] = [];
  getLabResultArray: any[] = [];
  labtrasId: any;
  labserviceId: any;
  billId: any;
  Ptype: any;
  lab_BillDetailId: any;
  labPtype: any
  selectedIndex: number | null = null;


  labSampleCollectionDetailByBillId(item: any, index: number, type) {
    if (this.getLabResultArray && this.getLabResultArray.length > 0) {
      this.getLabResultArray.forEach((item, index) => {
        if (this.editCache[index] && this.editCache[index].edit) {
          this.editCache[index].edit = false;
        }
      });
    }
    this.sampleCollectionDetailByBillIdArray = [];
    this.getLabResultArray = [];
    this.selectedIndex2 = -1;
    this.labResultEntryModel.remark = null;
    this.labResultEntryModel.clinicalName = null;
    this.labResultEntryModel.SINNO = null;
    this.labResultEntryModel.TestName = null;
    // this.printArray = null;
    this.labResultClinical('LABRESULTCLINICALDEPT');
    this.selectedpK_BIllID = item.pK_BIllID;
    this.patient_Id = item.patientID;
    this.selectedIndex = index;
    let Payload = {
      "BillID": this.selectedpK_BIllID
    }
    this.otherService.GetLabSampleCollectionDetailByBillId(Payload).pipe(takeUntil(this.destroytestResultlist$)).subscribe((res) => {
      if (this.cleanRoute === 'labentry/testresultapproval') {
        this.sampleCollectionDetailByBillIdArray = res.filter(item => item.isPerformed === true);
      } else {
        this.sampleCollectionDetailByBillIdArray = res;
      }
      if (this.sampleCollectionDetailByBillIdArray.length > 0) {
        this.selectedIndex2 = type
        if (type == 0) {
          this.labResultEntryModel.remark = this.sampleCollectionDetailByBillIdArray[0].labComments
          this.getLabResult(this.sampleCollectionDetailByBillIdArray[0].pK_TranID, this.sampleCollectionDetailByBillIdArray[0].pK_ServiceId, this.sampleCollectionDetailByBillIdArray[0].pK_BIllID, this.sampleCollectionDetailByBillIdArray[0].pType)
        } else {
          this.getLabResult(this.labtrasId, this.labserviceId, this.billId, this.Ptype)
          this.labResultEntryModel.remark = this.sampleCollectionDetailByBillIdArray.filter(item => item.pK_TranID == this.labtrasId)[0]?.labComments

        }
      }
      // this.filteredSampleCollectionDetails = [...res];
      if (this.cleanRoute === 'labentry/testresultentry') {
        if (this.labResultEntryModel.approveStatus == 'ALL') {
          this.filteredSampleCollectionDetails = [...res];
        } else {
          this.filteredSampleCollectionDetails = res.filter(item => item.testApprovalStatus == this.labResultEntryModel.approveStatus);
        }
      } else if (this.cleanRoute === 'labentry/testresultapproval') {
        this.filteredSampleCollectionDetails = res.filter(item => item.isPerformed === true);
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  selectedTranId2: any;
  selectedIndex2: number | null = null;
  SampleCollectionDetails(item, index: number) {
    this.labtrasId = item.pK_TranID;
    this.labserviceId = item.pK_ServiceId;
    this.billId = item.pK_BIllID
    this.Ptype = item.pType
    this.lab_BillDetailId = item.pK_BillDetailId;
    this.labResultEntryModel.remark = item.labComments
    this.selectedIndex2 = index;
    this.getLabResult(this.labtrasId, this.labserviceId, this.billId, this.Ptype)
    if (this.getLabResultArray && this.getLabResultArray.length > 0) {
      this.getLabResultArray.forEach((item, index) => {
        if (this.editCache[index] && this.editCache[index].edit) {
          this.editCache[index].edit = false;
        }
      });
    }

  }

  getLabResult(TranId: any, ServiceId: any, billID: any, Ptype: any) {
    this.otherService.GetLabResult(TranId, ServiceId, billID, Ptype).pipe(takeUntil(this.destroytestResultlist$)).subscribe((res) => {
      this.getLabResultArray = res;
      this.editCache = {};
      this.getLabResultArray.forEach((item: any, index: number) => {
        this.editCache[index] = {
          edit: item.pK_ResultID == null || item.pK_ResultID == 0 ? true : false
        };
      });
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  search: any
  filterByLabTable(value, type) {
    if (type == 1) {
      this.labResultEntryModel.SINNO = value
      this.search = this.labResultEntryModel.SINNO.toLowerCase();
      this.filteredSampleCollectionDetails = this.sampleCollectionDetailByBillIdArray.filter(item =>
        item.sinNo?.toLowerCase().includes(this.search)
      );
      this.getLabResultArray = null;
      this.selectedIndex2 = null;
      this.labResultEntryModel.remark = null;
    } else if (type == 2) {
      this.labResultEntryModel.TestName = value;
      this.search = this.labResultEntryModel.TestName.toLowerCase();
      this.filteredSampleCollectionDetails = this.sampleCollectionDetailByBillIdArray.filter(item =>
        item.testName?.toLowerCase().includes(this.search)
      );
      this.getLabResultArray = null;
      this.selectedIndex2 = null;
      this.labResultEntryModel.remark = null;
      //  this.printArray = null;
    }
    this.applyCombinedFilter();
  }
  updateEditCache(): void {
    this.getLabResultArray.forEach((item, index) => {
      this.editCache[index] = {
        edit: false,
        data: { ...item },
      };
    });
  }

  Edit(index: number, item: any) {
    this.updateEditCache();
    this.editCache[index].edit = true;
    item.isEdited = true;
  }

  saveedit(index: number, item: any) {
    this.editCache[index].edit = false;
  }


  savelaResult(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 2000);
    if (this.getLabResultArray && this.getLabResultArray.length > 0) {
      this.getLabResultArray.forEach((item, index) => {
        if (this.editCache[index] && this.editCache[index].edit) {
          this.editCache[index].edit = false;
        }
      });
    }
    let postLabResultArray: any[] = [];
    let minValue = true;
    let maxValue = true
    this.getLabResultArray.forEach((item: any) => {
      if (!item.minValue) {
        minValue = false;
      }
      if (!item.maxValue) {
        maxValue = false;
      }

      postLabResultArray.push({
        "PK_ResultID": item.pK_ResultID ? item.pK_ResultID : 0,
        "FK_TranID": this.labtrasId ? this.labtrasId : this.sampleCollectionDetailByBillIdArray[0].pK_TranID,
        "FK_HeadID": item.fK_HeadID,
        "ResultValue": item.resultValue,
        "MachineReading": item.machineReading,
        "FlagId": item.flagId,
        "MaxValue": item.maxValue,
        "MinValue": item.minValue,
        "ManualValue": item.manualValue,
        "Comments": item.comments,
        "IsPrint": item.isPrint,
        "SeqNo": item.seqNo,
        "PK_BillDetailId": this.lab_BillDetailId ? this.lab_BillDetailId : this.sampleCollectionDetailByBillIdArray[0].pK_BillDetailId,
        "LabComments": this.labResultEntryModel.remark,
        "PType": this.labPtype,
        "isEdit": item.pK_ResultID ? true : false
      })
    })

    if (!this.labtrasId && !this.sampleCollectionDetailByBillIdArray[0].pK_TranID) {
      this.dashboardService.openSnackBar("Please Select row first", "OK");
      return;
    }

    if (!minValue || !maxValue) {
      this.dashboardService.openSnackBar("Please add min and max value in master database", "OK");
      return;
    }

    // if (!maxValue) {
    //   this.dashboardService.openSnackBar("Please fill the maxValue fields", "OK");
    //   return;
    // }

    let payload = {
      InsertLabResultDetail: postLabResultArray
    }
    this.otherService.InsertLabResultDetail(payload).pipe(takeUntil(this.destroytestResultlist$)).subscribe((res) => {
      if (this.labtrasId && this.labserviceId && this.billId && this.Ptype) {
        this.getLabResult(this.labtrasId, this.labserviceId, this.billId, this.Ptype);
      }
      this.labSampleCollectionDetailByBillId({ pK_BIllID: this.selectedpK_BIllID }, this.selectedIndex, this.selectedIndex2)
      const premassage = postLabResultArray.some(item => item.pK_ResultID == 0);
      this.dashboardService.openSnackBar(premassage ? "Record Saved Successfully" : "Record Updated Successfully", "OK");
      postLabResultArray = [];
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error && err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  deliverystatus(type) {
    if (this.getLabResultArray && this.getLabResultArray.length > 0) {
      this.getLabResultArray.forEach((item, index) => {
        if (this.editCache[index] && this.editCache[index].edit) {
          this.editCache[index].edit = false;
        }
      });
    }
    var postSampleCollectionDetailArray: any[] = [];
    if (!this.sampleCollectionDetailByBillIdArray || this.sampleCollectionDetailByBillIdArray == null) {
      this.dashboardService.openSnackBar("Please select row first", "OK");
      return;
    }
    this.sampleCollectionDetailByBillIdArray.forEach((item) => {
      postSampleCollectionDetailArray.push({
        "HeadName": type,
        "PK_TranID": item.pK_TranID,
        "FK_BillDetailID": item.pK_BillDetailId,
        "IsEdit": true
      })
    })
    let payload = {
      InsertLabSampleCollectionDetail: postSampleCollectionDetailArray
    }
    this.otherService.InsertLabSampleCollectionDetail(payload).pipe(takeUntil(this.destroytestResultlist$)).subscribe((res: any) => {
      if (res && res.statusCode === "1") {
        this.labSampleCollectionDetail();
        let msg = '';
        if (type == 'UPDATEDELIVERYSTATUS') {
          msg = 'Record delivered successfully';
        } else if (type == 'UPDATEVERIFIEDSTATUS') {
          msg = 'Record verified successfully';
        } else if (type == 'UPDATEAPPROVALSTATUS') {
          msg = 'Record approved successfully';
        }

        this.dashboardService.openSnackBar(msg, "OK")
        // this.dashboardService.openSnackBar(res.message, "OK");
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  branchmansterObj: any = {};
  getBranchDetail(id) {
    this.branchmansterObj = {};
    this.dashboardService.subscriptions = this.branchMatserService.getBrachMasterItem(id).subscribe((x: any) => {
      this.branchmansterObj = x[0];
    })
  }

  printArray: any[] = [];
  checkmultiPrint(item: any, check: boolean) {
    if (check) {
      this.printArray.push(item);
    } else {
      const index = this.printArray.indexOf(item);
      if (index > -1) {
        this.printArray.splice(index, 1);
      }
    }
  }

  printMultipleselect(type) {
    let fkBillDetailIdValue = 0;
    let pkbillid = 0
    if (type == 1) {
      if (this.printArray.length == 0) {
        return this.dashboardService.openSnackBar("Please Select row", "OK");
      }
      const checkapproval = this.printArray.filter(x => x.approvedBy != null && x.approvedBy != '');
      if (checkapproval.length == 0) {
        return this.dashboardService.openSnackBar("Approval required before print this record", "OK");

      }

      if (checkapproval.length === 1) {
        fkBillDetailIdValue = checkapproval[0]?.pK_BillDetailId;
        pkbillid = 0
      } else if (checkapproval.length > 1) {
        pkbillid = checkapproval[0]?.pK_BIllID;
        fkBillDetailIdValue = 0
      }
    }

    let payload = {
      "WebReportPrintMaster": {
        "module": "Laboratory",
        "printOption": "Print Selected",
        "printType": "WebNetramReport",
        "Pk_RegId": this.patient_Id,
        // "Fk_BillDetailIDs":   this.sampleCollectionDetailByBillIdArray[0].pK_BillDetailId ?  this.sampleCollectionDetailByBillIdArray[0].pK_BillDetailId :this.lab_BillDetailId,
        "Fk_BillDetailIDs": fkBillDetailIdValue,
        "Pk_BillId": pkbillid,
        "DeptName": "",
        "OPDLabReportArray": "Y",
        "BILLINGCOMPANYNAME": this.authService.Loggeduser.billingcompanyname,
        "LINE1": this.branchmansterObj.line1,
        "LINE2": this.branchmansterObj.line2,
        "LINE3": this.branchmansterObj.line3,
        "LINE4": this.branchmansterObj.line4,
        "HOSPITALIMAGE": window.location.origin + "/" + this.authService.loginclientlogo,
        "COMPANYIMAGE": window.location.origin + "/" + this.authService.leftbottomlogosm,
        "CERTIFICATE1IMAGE": window.location.origin + "/" + this.authService.nabhlogo,
        "CERTIFICATE2COMPANYIMAGE": "",
      }
    }
    this.ipdService.GetWebReportPrint(payload).subscribe((x: any) => {
      if (x.length > 0) {
        let printContents, popupWin;
        printContents = x[0].printTemplate;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
        <html>
         
      <body onload="window.print();">${printContents}
      </body>
        </html>`
        );

        popupWin.document.close();


      } else {
        this.dashboardService.openSnackBar("Report Template Not Set", "OK");
      }
    })
  }

  ngOnDestroy() {
    this.destroytestResultlist$.next(true);
    this.destroytestResultlist$.unsubscribe();
    this.labSampleCollectionDetailArray = null;
    this.filteredSampleCollectionDetails = null;
    this.deliveryArray = null;
    this.approvalArray = null;
    this.clinicalArray = null;
    this.getLabResultArray = null;
    this.filteredDeliveryArray = null;
    this.filteredLabapproveStatusArray = null;
    this.filteredclinicalArray = null;
    this.filteredLabBranchArray = null;
    this.printArray = null;
  }
}
